import parse from 'url-parse'
import { REGION } from '@ms/config/app'

const KEY_CHANNEL = `${REGION}-channel`

// 解析渠道
export const getChannel = () => {
  const { query } = parse(location.href, true)
  let channel = query.from || sessionStorage.getItem(KEY_CHANNEL)
  // 如果当前页没有渠道号的话，尝试继承来源页的渠道号
  if (!channel) {
    const { query: referrerQuery, hostname } = parse(document.referrer, true)
    if (hostname === location.hostname && referrerQuery.from) {
      channel = referrerQuery.from
      const search = location.search ? `${location.search}&from=${channel}` : `?from=${channel}`
      history.replaceState(null, document.title, search)
    }
  }
  return channel
}

// 设置渠道
export const setChannel = (channel = '') => {
  channel = channel || parse(location.href, true).query.from
  if (channel) {
    sessionStorage.setItem(KEY_CHANNEL, channel)
  }
}

// 获取 creator 渠道
const getKolCreatorChannel = () => {
  let channel = getChannel()
  if (channel) {
    channel = channel.replace(/^creator_/, '')
  }
  return channel || ''
}

// 标识 creator 渠道
export const formatKolCreatorChannel = (channel) => 'creator_' + channel
// 检测是否是 creator 渠道
export const isKolCreatorChannel = (channel) => /^creator_/.test(channel)

// 清除 creator 渠道
export const removeKolCreatorChannel = () => {
  const channel = getChannel()
  if (channel && /^creator_/.test(channel)) {
    sessionStorage.removeItem(KEY_CHANNEL)
    const query = new URLSearchParams(location.search)
    query.delete('from')
    const newUrl = `${window.location.pathname}?${query.toString()}`
    history.replaceState(null, '', newUrl)
  }
}

export const getKolChannelHeaders = () => {
  const headers = {}
  const kolChannel = getKolCreatorChannel()
  if (kolChannel) {
    headers.channel = kolChannel
  }
  return headers
}
